import { render, staticRenderFns } from "./SubActivation.vue?vue&type=template&id=0ef25a57&scoped=true&"
import script from "./SubActivation.vue?vue&type=script&lang=js&"
export * from "./SubActivation.vue?vue&type=script&lang=js&"
import style0 from "./SubActivation.vue?vue&type=style&index=0&id=0ef25a57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef25a57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VForm,VSheet,VTextField})
